import { render, staticRenderFns } from "./TriggerSettings.vue?vue&type=template&id=14bc4774&scoped=true"
import script from "./TriggerSettings.vue?vue&type=script&lang=js"
export * from "./TriggerSettings.vue?vue&type=script&lang=js"
import style0 from "./TriggerSettings.vue?vue&type=style&index=0&id=14bc4774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc4774",
  null
  
)

export default component.exports